import { Button, Col, DatePicker, Form, Input, Row, Space, Table, Tabs, Upload, UploadFile, UploadProps } from 'antd';
import { KhenThuong } from '../../models/nhanvien/KhenThuong';
import { dateCommon, validateMessages } from '../../helpers/common';
import { DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined, UploadOutlined, EyeOutlined } from '@ant-design/icons';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { luuKhenThuong, xoaKhenThuong } from '../../services/nhanvien';
import { toast } from 'react-toastify';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import dayjs from 'dayjs';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { urlAdmin } from '../../constants';

const KhenThuongBox = ({ listData, idNhanVien, isThemMoi, onSubmit }: { listData?: Array<KhenThuong>, idNhanVien?: number, isThemMoi?: boolean, onSubmit: () => void }) => {
    var dataSource = (listData || []).map((item: any, index) => { item.key = index; return item; });
    const [loading, setLoading] = useState(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);

    const [selectedKT, setSelectedKT] = useState<KhenThuong>(new KhenThuong);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    useEffect(() => {
        var fileHienTai: any = (selectedKT?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
            };
        });
        setFileList(fileHienTai)
    }, [selectedKT]);

    const props: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa([...idsTaiLieuXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };

    const [form] = Form.useForm();
    const setFormDetailModal = (value: KhenThuong | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idNhanVien": idNhanVien,
            "ngayQuyetDinh": value?.ngayQuyetDinh ? dayjs(dateCommon.formatDate(value?.ngayQuyetDinh), "DD/MM/YYYY") : null,
            "soQuyetDinh": value?.soQuyetDinh || "",
            "thanhTichKhenThuong": value?.thanhTichKhenThuong || "",
            "hinhThucKhenThuong": value?.hinhThucKhenThuong || "",
            "nguoiKy": value?.nguoiKy || "",
            "chucVuNguoiKy": value?.chucVuNguoiKy || "",
            "capThanhTich": value?.capThanhTich || "",
            "donViKyQuyetDinh": value?.donViKyQuyetDinh || ""
        });
        setShowModalChiTiet(true);
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            await luuKhenThuong(values, fileList, idsTaiLieuXoa);
            setShowModalChiTiet(false);
            setSelectedKT(new KhenThuong);
            toast.success('Lưu khen thưởng thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        setLoading(false);
        onSubmit();
    };

    const onDelete = async () => {
        try {
            setLoading(true);
            await xoaKhenThuong(idXoa);
            toast.success('Xoá khen thưởng thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setLoading(false);
        onSubmit();
    }
    return (
        <div className="card-outline">
            {idXoa > 0 && <ModalTextForm show={idXoa > 0}
                title="Xoá khen thưởng"
                handleClose={() => setIdXoa(0)}
                handleSave={onDelete}>
                Xác nhận xóa khen thưởng đang chọn
            </ModalTextForm>}
            {showModalChiTiet && <ModalTextForm title="Quản lý khen thưởng"
                hideFooter
                show={showModalChiTiet}
                handleClose={() => { setShowModalChiTiet(false); setSelectedKT(new KhenThuong); } }
            >
                {isThemMoi ? <Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item hidden name="id"><Input /></Form.Item>
                    <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Ngày quyết định"
                                name="ngayQuyetDinh"
                                rules={[{ required: true }]}
                            >
                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày quyết định" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Số quyết định"
                                name="soQuyetDinh" >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item
                        label="Thành tích khen thưởng"
                        name="thanhTichKhenThuong"
                        rules={[{ required: true }]} >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Hình thức khen thưởng"
                        name="hinhThucKhenThuong"
                        rules={[{ required: true }]} >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Cấp thành tích"
                                    name="capThanhTich"
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Đơn vị ký quyết định"
                                    name="donViKyQuyetDinh"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Người ký"
                                    name="nguoiKy"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Chức vụ người ký"
                                    name="chucVuNguoiKy" >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <Upload {...props}>
                                    <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                </Upload>
                            </Col>
                        </Row>
                        <Button type="primary" className="float-right mt-2" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                            Lưu
                        </Button>
                    </Form.Item>
                </Form>
                    :
                    <>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Ngày quyết định</div>
                                    <label>{selectedKT?.ngayQuyetDinh != null ? dateCommon.formatDate(selectedKT?.ngayQuyetDinh) : ""}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Số quyết định</div>
                                    <label>{selectedKT?.soQuyetDinh}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Thành tích khen thưởng</div>
                                    <label>{selectedKT?.thanhTichKhenThuong}</label>
                                </div>
                                <Form.Item
                                    label="Thành tích khen thưởng"
                                    name="thanhTichKhenThuong" >
                                    {selectedKT?.thanhTichKhenThuong}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Hình thức khen thưởng</div>
                                    <label>{selectedKT?.hinhThucKhenThuong}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Cấp thành tích</div>
                                    <label>{selectedKT?.capThanhTich}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Đơn vị ký quyết định</div>
                                    <label>{selectedKT?.donViKyQuyetDinh}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Người ký</div>
                                    <label>{selectedKT?.nguoiKy}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Chức vụ người ký</div>
                                    <label>{selectedKT?.chucVuNguoiKy}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <div className="mb-1">
                                    <div>File đính kèm</div>
                                    <Upload {...props} disabled={true}>
                                    </Upload>
                                </div>
                            </Col>
                        </Row>
                    </>}
            </ModalTextForm>}
            <Tabs tabBarExtraContent={isThemMoi ?
                <Button
                    className="hrm-btn hrm-btn-warning"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
                : null} defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Khen thưởng',
                        children:
                            <div className="card">
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={dataSource}
                                    pagination={false}
                                    rowClassName={(record, index) => {
                                        return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                    }}
                                ><Column
                                        title="STT"
                                        key="STT"
                                        render={(value, record, index) =>
                                        (
                                            <>
                                                {index + 1}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Ngày quyết định"
                                        key="ngayQuyetDinh"
                                        render={(value: KhenThuong, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.ngayQuyetDinh)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column title="Số quyết định" key="soQuyetDinh" dataIndex="soQuyetDinh" />
                                    <Column title="Hình thức khen thưởng" dataIndex="hinhThucKhenThuong" key="noiDuhinhThucKhenThuongngKhenThuong" />
                                    <Column title="Thành tích khen thưởng" key="thanhTichKhenThuong" dataIndex="thanhTichKhenThuong" />
                                    <Column title="Thẩm quyền" dataIndex="donViKyQuyetDinh" key="donViKyQuyetDinh" />
                                    <Column title="Người ký quyết định" dataIndex="nguoiKy" key="nguoiKy" />
                                    <Column title="Nơi ký quyết định" dataIndex="donViKyQuyetDinh" key="donViKyQuyetDinh" />
                                    {isThemMoi ?
                                        <Column width="10%" title="" key="action"
                                            render={(value: KhenThuong, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                        icon=<EditOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); setSelectedKT(value) }}
                                                    >
                                                        Sửa
                                                    </Button>
                                                    <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                        onClick={() => { setIdXoa(value.id) }}
                                                        icon=<DeleteOutlined rev="" />
                                                    >
                                                        Xóa
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        /> :
                                        <Column width="10%" title="" key="action"
                                            render={(value: KhenThuong, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Xem"
                                                        icon=<EyeOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); setSelectedKT(value) }}
                                                    >
                                                        Xem
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        />
                                    }
                                </Table>
                            </div>
                    },
                ]}>
            </Tabs>
        </div>
    );
};

export default KhenThuongBox;
